import useLocalStorageState from "use-local-storage-state";
import { Site } from "@labs/shared/types/Site.ts";

export const useLocalSitesState = () =>
  useLocalStorageState<Site[]>("sites", {
    defaultValue: [],
  });
